import { enUS, frFR } from '@clerk/localizations';

type TranslateFn = (key: string) => string;
type ClerkLocalization = typeof enUS;

/**
 * Clerk UI locale pack for the app language, with brand overrides for
 * sign-in / sign-up titles that match our i18n catalog.
 */
export function getClerkLocalization(language: string, t: TranslateFn): ClerkLocalization {
  const base = language.startsWith('fr') ? frFR : enUS;

  return {
    ...base,
    signIn: {
      ...base.signIn,
      start: {
        ...base.signIn?.start,
        title: t('auth.clerk.signIn'),
      },
    },
    signUp: {
      ...base.signUp,
      start: {
        ...base.signUp?.start,
        title: t('auth.clerk.createAccount'),
        actionText: t('auth.clerk.alreadyHaveAccount'),
        actionLink: t('auth.clerk.signIn'),
      },
    },
  };
}
